import { render } from "./SitesView.vue?vue&type=template&id=0f374798&scoped=true&language=ts"
import script from "./SitesView.vue?vue&type=script&lang=js"
export * from "./SitesView.vue?vue&type=script&lang=js"

import "./SitesView.vue?vue&type=style&index=0&id=0f374798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f374798"]])

export default __exports__